import React, { useRef, useState, useEffect } from "react";
import FormField from "../../forms/form-field";
import FormSelect from "../../forms/form-select";
import Tooltip from "../../tooltip/tooltip";
import useLocationStore from "../config/use-location-store";
import { instanceMob } from "../../../utils/utils";
import BaseModal from "../../modals/base-modal";

const SaleStepUserInfo = ({ show, onClose, onNext }) => {
    const formRef = useRef(null);
    const [userData, setUserData] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isValid, setIsValid] = useState(false);
    const [saleNumber, setSaleNumber] = useState("");
    const [noneCustomer, setNoneCustomer] = useState(false);
    const selectedLocation = useLocationStore((state) => state.selectedLocation);

    const formFields = [
        {
            Component: FormField,
            label: "Fecha",
            name: "saleDate",
            type: "date",
            value: new Date().toISOString().split("T")[0],
            readOnly: true,
            width: "65%",
            isLoading,
        },
        {
            Component: FormField,
            label: "# Registro",
            name: "registry_number",
            type: "text",
            value: saleNumber,
            readOnly: true,
            isLoading,
        },
        {
            Component: FormField,
            label: "Usuario que Registra",
            name: "registeredByUser",
            type: "text",
            value: userData ? `${userData.first_name} ${userData.last_name} (${userData.email})` : "",
            readOnly: true,
            isLoading,
        },
        {
            Component: FormField,
            label: "Locación",
            name: "locationName",
            type: "text",
            value: selectedLocation?.name || "",
            readOnly: true,
            isLoading,
        },
        {
            Component: FormSelect,
            label: "A favor de",
            name: "customerId",
            options: customers,
            placeholder: "Selecciona un cliente",
            tooltip: "Selecciona un cliente registrado en Elevva o crea uno nuevo si aún no está en el sistema.",
            searchable: true,
            required: true,
            isLoading,
            value: null,
            onChange: (value) => {
                const selectedValue = typeof value === "string" ? value : value?.target?.value;
                setNoneCustomer(Boolean(selectedValue === ""));
            },
        },
        {
            Component: FormField,
            label: "Concepto de venta",
            name: "saleConcept",
            type: "text",
            placeholder: "Escribe el concepto",
            required: true,
            isLoading,
        },
    ];

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(formRef.current);
        const data = Object.fromEntries(formData.entries());
        onNext(data);
    };

    const validateForm = () => {
        if (!formRef.current) return;
        const requiredInputs = formRef.current.querySelectorAll("[required]");
        let valid = true;
        requiredInputs.forEach((input) => {
            if (noneCustomer && input.name === "customerId") return;
            if (!input.value || input.value.trim() === "") {
                valid = false;
            }
        });
        setIsValid(valid);
    };

    useEffect(() => {
        const storedUser = {
            email: localStorage.getItem("email"),
            first_name: localStorage.getItem("first_name"),
            last_name: localStorage.getItem("last_name"),
            id: localStorage.getItem("id"),
        };
        setUserData(storedUser);
    }, []);

    useEffect(() => {
        instanceMob
            .get(`admin/customers/accounting`)
            .then((res) => res.data)
            .then((data) => {
                const formatted =
                    data?.map((c) => ({
                        value: c?.id,
                        label: `${c?.name} (${c.email})`,
                    })) || [];

                const withNoRegister = [
                    { value: "", label: "Usuario no registra" },
                    ...formatted,
                ];

                setCustomers(withNoRegister);
            })
            .catch((err) => console.error("Error cargando clientes:", err))
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    useEffect(() => {
        if (!selectedLocation?.id) return;
        setIsLoading(true);
        instanceMob
            .get("admin/accounting/register-number", {
                params: { location_id: selectedLocation.id },
            })
            .then((res) => {
                setSaleNumber(res.data?.next_registry_number || "");
            })
            .catch((err) => console.error("Error cargando número de registro:", err))
            .finally(() => setIsLoading(false));
    }, [selectedLocation]);

    useEffect(() => {
        validateForm();
    }, [noneCustomer]);

    return (
        <BaseModal
            show={show}
            onClose={onClose}
            title="Registro de venta"
            onSave={() => formRef.current.requestSubmit()}
            saveText="Continuar"
            disableSave={!isValid}
            size={"lg"}
        >
            <form
                ref={formRef}
                onSubmit={handleSubmit}
                onChange={validateForm}
                className="d-flex flex-column gap-2"
            >
                {formFields.map((field, index) => {
                    const FieldComponent =
                        typeof field.Component === "string"
                            ? React.createElement(field.Component, { ...field })
                            : <field.Component {...field} />;

                    if (field.tooltip) {
                        return (
                            <Tooltip
                                key={index}
                                title={field.label}
                                description={field.tooltip}
                                position="right"
                                variant="rich"
                            >
                                {FieldComponent}
                            </Tooltip>
                        );
                    }
                    return <React.Fragment key={index}>{FieldComponent}</React.Fragment>;
                })}

                <input type="hidden" name="userId" value={userData?.id || ""} />
                <input type="hidden" name="locationId" value={selectedLocation?.id || ""} />
                <input type="hidden" name="none_customer" value={Boolean(noneCustomer)} />
            </form>
        </BaseModal>
    );
};

export default SaleStepUserInfo;
